import {IDisplayColumn} from '@shared/models/idb';


export function deepCloneDisplayCols(cols: IDisplayColumn[]): IDisplayColumn[] {
  return cols.map(col => ({
    ...col,
    childs: col.childs ? col.childs.map(child => ({...child})) : undefined,
  }));
}
